import { useEffect } from 'react';
import { BillType } from '@mews-commander/data-access';
import { fetchSendEmailDialogData } from '@mews-commander/legacy-entities/src/actions/companies';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { LocalizedText, lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Container, DropDownButton, DropdownItem, IconButton, IconName, Tooltip } from '@optimus-web/core';
import { openSendEmailDialog, SendEmailType } from './SendFinancialDocumentToEmailAction';
import { SendFinancialDocumentToEmailAction } from './types';

interface Props {
    action: SendFinancialDocumentToEmailAction;
    showPrintReasonDialog: boolean;
    setShowPrintReasonDialog: (show: boolean) => void;
}

const TooltippedButton = Tooltip(IconButton);

export const SendEmailAndReminderForInvoiceToEmailAction = ({
    action,
    showPrintReasonDialog,
    setShowPrintReasonDialog,
}: Props) => {
    const dispatch = useCommanderThunkDispatch();

    useEffect(() => {
        dispatch(fetchSendEmailDialogData({ ownerId: action.ownerId, companyId: action.companyDetailsId }));
    }, [dispatch, action.ownerId, action.companyDetailsId]);

    const {
        requirePrintReasonOnReprint,
        isReprint,
        financialDocumentId,
        documentType,
        ownerId,
        companyDetailsId,
        requirePrintReasonOnTemplateChange,
        firstUsedTemplateType,
        allowedTemplateTypes,
        billType,
        lastUsedTemplateType,
    } = action;

    const openSendBillDialog = (type: SendEmailType) => {
        dispatch(
            openSendEmailDialog({
                financialDocumentId,
                documentType,
                ownerId,
                companyId: companyDetailsId,
                showPrintReason: isReprint || showPrintReasonDialog,
                setShowPrintReason: requirePrintReasonOnReprint ? setShowPrintReasonDialog : undefined,
                firstUsedTemplateType,
                requirePrintReasonOnTemplateChange,
                allowedTemplateTypes,
                type,
                lastUsedTemplateType,
            })
        );
    };

    return (
        <Container padding={['0', '100', '0', '0']}>
            {billType === BillType.Receipt ? (
                <TooltippedButton
                    icon={IconName.Mails}
                    onClick={() => openSendBillDialog('SendBill')}
                    tooltip={lt(TextKey.SendBillToEmail)}
                    type="button"
                />
            ) : (
                <DropDownButton placement="bottom-end" icon={IconName.Mails} size="medium">
                    <DropdownItem
                        label={<LocalizedText textKey={TextKey.SendBill} />}
                        onClick={() => openSendBillDialog('SendBill')}
                    />
                    {billType === BillType.Invoice ? (
                        <DropdownItem
                            label={<LocalizedText textKey={TextKey.SendReminder} />}
                            onClick={() => openSendBillDialog('SendReminder')}
                        />
                    ) : null}
                </DropDownButton>
            )}
        </Container>
    );
};
